(() => {
  if (customElements.get('article-aside')) return;
  // Collapses the rail signup while the end-of-article signup is on screen, so the two never show together.
  customElements.define('article-aside', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      const inline = document.querySelector('[data-article-newsletter="inline"]');
      const rail = this.querySelector('.article-aside__newsletter');
      if (!inline || !rail || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(([entry]) => {
        // Keep the rail form while someone is typing in it.
        if (entry.isIntersecting && rail.contains(document.activeElement)) return;
        this.toggleAttribute('data-inline-visible', entry.isIntersecting);
        rail.inert = entry.isIntersecting;
      });
      this.observer.observe(inline);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
})();
